import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Election } from 'src/app/models/Election';
import { AuthService } from 'src/app/services/auth.service';
import { CommitteeService } from 'src/app/services/modelService/committee.service';
import { ElectionService } from 'src/app/services/modelService/election.service';
import { ToastService } from 'src/app/util/toast.service';

@Component({
  selector: 'app-election-list',
  templateUrl: './election-list.page.html',
  styleUrls: ['./election-list.page.scss'],
})
export class ElectionListPage implements OnInit {

  constructor(private router: Router, private toast: ToastService, public es: ElectionService, private auth: AuthService, public cs: CommitteeService) { }

  ngOnInit() {
    this.auth.getLoggedInEmployee().then(() => {
      this.es.getAllElection();
    })
  }

  clickElection(election: Election) {
    if (this.cs.myMemberShip && this.cs.myMemberShip.status == 'Verified') {

      if (election) {
        this.router.navigate(['election-details/' + election.id])
      } else {
        this.es.election = new Election();
        this.router.navigate(['election-edit']);
      }
    } else {
      this.toast.warning("Only committee members can participate in election.");
    }
  }

}
